export default __webpack_public_path__ + "static/media/Close_round.ee2dd3d6.svg";